export default __webpack_public_path__ + "static/thebottomline15-707863f8d6040765c078d9f66621aa39.jpg";